export const startSteps = [
    {
        id: 0,
        type: "cards-step",
        description: "",
        title: "Was können wir für Sie tun?",
        options: [
          {
            id: "1",
            value: "Eignungsanalyse Wärmepumpe",
            next: 100,
            stepRange: { from: 100, to: 199 },
            options: {
              icon: "/libs/wizard/check/svg/waermepumpe-eignungsanalyse.svg",
              text: "Eignungsanalyse Wärmepumpe",
              size: "m",
            },
          },
          {
            id: "2",
            value: "Neue Heizung Planen",
            next: 200,
            stepRange: { from: 200, to: 299 },
            options: {
              icon: "https://www.energiewechsel.de/KAENEF/Redaktion/DE/Bilder/Icons/heizungswegweiser.svg?__blob=normal&v=3",
              text: "Neue Heizung Planen",
              size: "m",
            },
          },
          {
            id: "3",
            value: "Förderung",
            next: 300,
            stepRange: { from: 300, to: 399 },
            options: {
              icon: "https://www.energiewechsel.de/KAENEF/Redaktion/DE/Bilder/Icons/foerderung.svg?__blob=normal&v=11",
              text: "Förderung",
              size: "m",
            },
          },
          {
            id: "4",
            value: "Energieberatung",
            next: 400,
            stepRange: { from: 400, to: 499 },
            options: {
              icon: "https://www.energiewechsel.de/KAENEF/Redaktion/DE/Bilder/Icons/energieberatung.svg?__blob=normal&v=5",
              text: "Energieberatung",
              size: "m",
            },
          },
        ],
      }
]